module.exports = {"apiKey":"AIzaSyCJeoEO5DMxH42te0ODb4nqV5VZe89-t_U","databaseURL":"https://pledger-148120.firebaseio.com","storageBucket":"pledger-148120.appspot.com","authDomain":"pledger-148120.firebaseapp.com","messagingSenderId":"568237024525","projectId":"pledger-148120"}


//////////////////
// WEBPACK FOOTER
// ./src/firebase.json
// module id = 945
// module chunks = 0